export const tenantWebsites = {
  "5f15542bf8254748f1d9dfad": {
    URL: "http://dev.seybazar.com/product-details"
  },
  "5f03136d81c4a86c8090dbb1": {
    URL: "https://www.seybazar.com/product-details"
  },
  "5fab802ae6d6ca486e267bb2": {
    URL: "http://dev.apagrofarm.com/product-details"
  },
  "5f990453c933b20ec4e5f8da": {
    URL: "https://www.apagrofarm.com/product-details"
  },
  "5fd4820587c05a4630533417": {
    URL: "http://dev.jalshri.com/product-details"
  },
  "5fd74bdaa1bcb94737894001": {
    URL: "http://shop.jalshri.com/product-details"
  }
};
